/*
 * @Author: Json Chen
 * @Date: 2021-07-09 11:16:41
 * @LastEditTime: 2022-06-01 16:35:52
 * @LastEditors: Json Chen
 * @Description:
 * @FilePath: /unifyxp-v2-store-portal/src/pages/Settings/Logistics/WarehouseLocations/index.tsx
 */

// import CommonHeader from '@/src/components/CommonHeader';
import { Button, SizeFittingTable } from '@/src/components/Antd';
import DroppableTable from '@/src/components/DroppableTable/DroppableTable';
import {
  getWareHouseLocations,
  setWareHouseLocationActivate,
  setWareHouseLocationDeactivate,
  setWareHouseLocationOrder,
} from '@/src/request/settings/logistics/wareHouseLocation';
import {
  isUserValid,
  storeResourceNameGenerator,
} from '@/src/tools/getUserInfo';
import {
  EPermissionSource,
  EnumCategory,
  EnumOperation,
  EnumSubCategory,
} from '@/src/types/common/resources';
import { useRequest } from 'ahooks';
import { Modal, Spin } from 'antd';
import React, { useEffect, useMemo, useRef, useState } from 'react';
import { useHistory } from 'react-router';
import { useI18n } from 'src/hooks/useRouterChange';
import { i18nGet } from 'src/tools/tools';
import styles from '../style.module.less';
import { get } from 'lodash';
import { getAreaCodes } from 'src/constrains/GlobalProvider/slice';
import { useSelector } from 'react-redux';

const permissions = () => {
  const add_edit_warehouse_information = isUserValid({
    source: EPermissionSource.store,
    resourcesGroup: [
      storeResourceNameGenerator({
        category: EnumCategory.Settings,
        subCategory: EnumSubCategory.SettingsLogisticsWarehouse,
        operation: EnumOperation.add_edit_warehouse_information,
      }),
    ],
  }); //view_warehouse_setting_page
  const view_warehouse_setting_page = isUserValid({
    source: EPermissionSource.store,
    resourcesGroup: [
      storeResourceNameGenerator({
        category: EnumCategory.Settings,
        subCategory: EnumSubCategory.SettingsLogisticsWarehouse,
        operation: EnumOperation.view_warehouse_setting_page,
      }),
    ],
  });
  const deactivate_warehouse = isUserValid({
    source: EPermissionSource.store,
    resourcesGroup: [
      storeResourceNameGenerator({
        category: EnumCategory.Settings,
        subCategory: EnumSubCategory.SettingsLogisticsWarehouse,
        operation: EnumOperation.deactivate_warehouse,
      }),
    ],
  });

  return {
    add_edit_warehouse_information,
    deactivate_warehouse,
    view_warehouse_setting_page,
  };
};
const WarehouseLocations = ({ warehouseList: list, setWarehouseList }) => {
  const i18n = useI18n();
  const getI18n = (str) => i18nGet(i18n, str);
  const {
    add_edit_warehouse_information,
    deactivate_warehouse,
    view_warehouse_setting_page,
  } = permissions();
  const history = useHistory();

  const [hideDeactivated, setHideDeactivated] = useState<boolean>(false);

  const target = useRef<any>();
  const [visiable, setVisiable] = useState<boolean>(false);
  const [modalProps, setModalProps] = useState<any>({});

  const { loading: getWareHouseLocationsLoading, run: _getWareHouseLocations } =
    useRequest(getWareHouseLocations, {
      manual: true,
      onSuccess(result) {
        setWarehouseList(result);
      },
    });

  const {
    loading: setWareHouseLocationOrderLoading,
    run: _setWareHouseLocationOrder,
  } = useRequest((params) => setWareHouseLocationOrder(params), {
    manual: true,
    onSuccess(result) {
      _getWareHouseLocations();
    },
  });
  const {
    loading: setWareHouseLocationActivateLoading,
    run: _setWareHouseLocationActivate,
  } = useRequest((uuid) => setWareHouseLocationActivate(uuid), {
    manual: true,
    onSuccess(result) {
      _getWareHouseLocations();
      setVisiable(false);
    },
  });

  const {
    loading: setWareHouseLocationDeactivateLoading,
    run: _setWareHouseLocationDeactivate,
  } = useRequest((uuid) => setWareHouseLocationDeactivate(uuid), {
    manual: true,
    onSuccess(result) {
      _getWareHouseLocations();
      setVisiable(false);
    },
  });

  const toSetting = (uuid?: string) => {
    history.push(
      `/settings/logistics/warehouselocation/setting/${uuid ? uuid : ''}${
        _list.length === 0 ? '?isdefault=true' : ''
      }`,
    );
  };

  const onItemClick = (current) => {
    target.current = current;

    if (current.active) {
      setModalProps({
        title: getI18n('storeLogistics.warehouseLocations.deactivateLocation'),
        okButtonProps: {
          type: 'danger',
        },
        content: getI18n(
          'storeLogistics.warehouseLocations.deactivateLocationContent',
        ),
        okText: getI18n('storeLogistics.warehouseLocations.deactivate'),
      });
    } else {
      setModalProps({
        title: getI18n('storeLogistics.warehouseLocations.activateLocation'),
        okButtonProps: {
          type: 'primary',
        },
        content: getI18n(
          'storeLogistics.warehouseLocations.activateLocationContent',
        ),
        okText: getI18n('storeLogistics.warehouseLocations.activate'),
      });
    }

    setVisiable(true);
  };

  const onTableChange = (data) => {
    _setWareHouseLocationOrder(data.map((i) => i.uuid));
  };

  const showHideDeactivatedHandler = () => {
    setHideDeactivated(!hideDeactivated);
  };

  const onModalConfirm = () => {
    const { current } = target;
    if (current.active) {
      _setWareHouseLocationDeactivate(current.uuid);
    } else {
      _setWareHouseLocationActivate(current.uuid);
    }
  };

  const onModalCancel = () => {
    setVisiable(false);
  };

  useEffect(() => {
    _getWareHouseLocations();
  }, []);

  // 是否展示 table 右下角的 Hide Deactivated Locations
  const showHideDeactivated = useMemo(
    () => list.some((item) => !item.defaultLocation && !item.active),
    [list],
  );

  // 页面用到的list
  const _list = useMemo(() => {
    const flist = list.filter((item) => {
      if (hideDeactivated) {
        return item.active;
      } else {
        return true;
      }
    });
    if (flist.length > 1) {
      return flist.map((item, index) => ({
        ...item,
        // active: !item.active,
        // defaultLocation = true 的,不可拖拽
        dragable: item.active,
        hideDragHandler: !item.active,
      }));
    } else {
      return flist;
    }
  }, [hideDeactivated, list]);
  const options = useSelector(getAreaCodes());

  // table 列数据
  const columns: any[] = [
    {
      title: getI18n('storeLogistics.warehouseLocations.locations'),
      key: 'title',
      default: true,
      minWidth: 800,
      childGenerate: (_, record) => {
        const areaCodeInText =
          get(
            options.find((i) => i.uuid === get(record, 'areaCodeInfo.uuid')),
            'areaCode',
          ) || '';
        return (
          <div
            className={`${record.active ? '' : styles.deactivateItem} ${
              styles.locationsWrap
            }`}>
            <div className={styles.locationsWrapTitle}>
              <span className={styles.locationName}>{record.locationName}</span>
              {record.defaultLocation && (
                <span className={styles.locationsDefault}>
                  {getI18n('storeLogistics.warehouseLocations.default')}
                </span>
              )}
            </div>
            <div>{`${record.addressLine} ${record.province?.name} ${record.country?.description}`}</div>
            <div>{`+${areaCodeInText} ${record.phone}`}</div>
          </div>
        );
      },
    },
    {
      title: getI18n(
        'general.advancedFilters.commonStoreProductsWithTable.actions',
      ),
      default: true,
      optional: true,
      align: 'center',
      width: 126,
      childGenerate: (_, record, index) => {
        return (
          <div className={styles.action}>
            {deactivate_warehouse ? (
              record.active ? (
                <span
                  className={
                    record.defaultLocation ? styles.unable : styles.danger
                  }
                  onClick={() =>
                    !record.defaultLocation && onItemClick(record)
                  }>
                  {getI18n('storeLogistics.warehouseLocations.deactivate')}
                </span>
              ) : (
                <span
                  className={styles.primary}
                  onClick={() => onItemClick(record)}>
                  {getI18n('storeLogistics.warehouseLocations.activate')}
                </span>
              )
            ) : null}

            {view_warehouse_setting_page ? (
              <span
                className={styles.primary}
                onClick={() => toSetting(record.uuid)}>
                {getI18n('general.edit')}
              </span>
            ) : null}
          </div>
        );
      },
    },
  ];

  // 设置拖拽
  const dragableColumns: any[] = [
    {
      title: getI18n('storeLogistics.warehouseLocations.priority'),
      key: 'index',
      default: true,
      minWidth: 84,
      align: 'center',
      childGenerate: (_, record, index) => {
        return (
          <div
            className={`${record.active ? '' : styles.deactivateItem} ${
              styles.action
            }`}>
            {index + 1}.
          </div>
        );
      },
    },
  ].concat(columns);

  return (
    <div className={styles.warehouseLocationsContainer}>
      <Spin
        spinning={
          getWareHouseLocationsLoading ||
          setWareHouseLocationOrderLoading ||
          setWareHouseLocationActivateLoading ||
          setWareHouseLocationDeactivateLoading
        }>
        {_list.length === 0 ? (
          <div className={styles.norConfig}>
            <div className={styles.title}>
              {getI18n(
                'storeLogistics.warehouseLocations.warehouseLocationsTitle',
              )}
            </div>
            <div className={styles.description}>
              {getI18n(
                'storeLogistics.warehouseLocations.warehouseLocationsDescription',
              )}
            </div>
          </div>
        ) : _list.length === 1 ? (
          <div className={styles.table}>
            <SizeFittingTable
              id='WarehouseLocations'
              rowKey='uuid'
              pagination={false}
              dataSource={_list}
              columns={columns}
              rowClassName={styles.row}
            />
          </div>
        ) : (
          <div>
            <div className={styles.haslistDesc}>
              <div className={styles.description}>
                {getI18n(
                  'storeLogistics.warehouseLocations.warehouseLocationsEmptyDescription',
                )}
              </div>
            </div>
            <div className={styles.table}>
              <DroppableTable
                id='WarehouseLocations'
                rowKey={'uuid'}
                dataSource={_list}
                columns={dragableColumns}
                onTableChange={onTableChange}
                pagination={false}
                hideAllDragHandlers={!add_edit_warehouse_information}
              />
            </div>
          </div>
        )}
      </Spin>
      <div className={`${_list.length != 0 ? styles.showOrHideBtns : ''}`}>
        <Button
          type='primary'
          className={styles.button}
          disabled={!add_edit_warehouse_information}
          onClick={() => toSetting()}>
          {getI18n('storeLogistics.warehouseLocations.addWarehouseLocation')}
        </Button>
        {showHideDeactivated && (
          <span
            onClick={showHideDeactivatedHandler}
            className={styles.showOrHideBtn}>
            {`${
              hideDeactivated
                ? getI18n('general.show')
                : getI18n('general.hide')
            }`}{' '}
            getI18n('') Deactivated Locations
          </span>
        )}
      </div>
      <Modal
        className={styles.warehouseModal}
        width={600}
        visible={visiable}
        confirmLoading={
          setWareHouseLocationActivateLoading ||
          setWareHouseLocationDeactivateLoading
        }
        {...modalProps}
        onCancel={onModalCancel}
        onOk={onModalConfirm}>
        {modalProps.content}
      </Modal>
    </div>
  );
};
export default WarehouseLocations;
